import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Link } from 'components/ui';

import LanguageLocaleUtils from 'utils/LanguageLocale';
import SignInFormTermsEN from 'components/GlobalModals/SignInModal/SignInFormTerms/locales/SignInFormTerms_en_US';
import SignInFormTermsFR from 'components/GlobalModals/SignInModal/SignInFormTerms/locales/SignInFormTerms_fr_CA';

const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(SignInFormTermsEN, SignInFormTermsFR);

function SignInFormTerms(props) {
    return (
        <Text
            is='p'
            lineHeight='tight'
            fontSize='xs'
            color='gray'
            my={4}
            {...props}
        >
            {getText('termsAndConditions')}
            <Link
                color='blue'
                underline={true}
                href='/terms-of-use'
                fontWeight='bold'
            >
                {getText('termsOfUse')}
            </Link>
            {getText('termsAndConditionsRest')}
            <Link
                color='blue'
                underline={true}
                href='/privacy-policy'
            >
                {getText('privacyPolicy')}
            </Link>
        </Text>
    );
}

export default wrapFunctionalComponent(SignInFormTerms, 'SignInFormTerms');
